import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach active org header from localStorage (client-side hint)
api.interceptors.request.use((config) => {
  const orgId = typeof window !== "undefined" ? localStorage.getItem("gc_active_org") : null;
  if (orgId) {
    config.headers = config.headers || {};
    config.headers["X-Org-Id"] = orgId;
  }
  return config;
});

export function formatErr(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Terjadi kesalahan";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join("; ");
  return String(detail);
}

export const IDR = (v) => {
  const n = Number(v || 0);
  return "Rp " + n.toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

export const NUM = (v, d = 2) => Number(v || 0).toLocaleString("id-ID", { maximumFractionDigits: d, minimumFractionDigits: 0 });

export const DATE = (v) => {
  if (!v) return "-";
  try {
    const d = new Date(v);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return String(v).slice(0, 10); }
};
